// extracted by mini-css-extract-plugin
export default {"lectureList":"Classroom_lectureList__S8+Uy","item":"Classroom_item__7M5oD","lectureDescription":"Classroom_lectureDescription__ZMLWI"};